import { createElement, Fragment } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { hasBlockSupport } from '@wordpress/blocks';
import { PanelBody } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import BlockStyles from '../block-styles';
import DefaultStylePicker from '../default-style-picker';
import InspectorControls from '../inspector-controls';
const StylesTab = ({
  blockName,
  clientId,
  hasBlockStyles
}) => {
  return createElement(Fragment, null, hasBlockStyles && createElement("div", null, createElement(PanelBody, {
    title: __('Styles')
  }, createElement(BlockStyles, {
    clientId: clientId
  }), hasBlockSupport(blockName, 'defaultStylePicker', true) && createElement(DefaultStylePicker, {
    blockName: blockName
  }))), createElement(InspectorControls.Slot, {
    group: "color",
    label: __('Color'),
    className: "color-block-support-panel__inner-wrapper"
  }), createElement(InspectorControls.Slot, {
    group: "filter"
  }), createElement(InspectorControls.Slot, {
    group: "typography",
    label: __('Typography')
  }), createElement(InspectorControls.Slot, {
    group: "dimensions",
    label: __('Dimensions')
  }), createElement(InspectorControls.Slot, {
    group: "border",
    label: __('Border')
  }), createElement(InspectorControls.Slot, {
    group: "styles"
  }));
};
export default StylesTab;
//# sourceMappingURL=styles-tab.js.map